import styles from '../../../MultiStepPMSLogin.module.scss'
import r1 from './r1.png'
import r2 from './r2.png'
import r3 from './r3.png'
import r4 from './r4.png'
import r5 from './r5.png'
import r6 from './r6.png'
import r7 from './r7.png'
import r8 from './r8.png'
import r9 from './r9.png'
import r10 from './r10.png'
import r11 from './r11.png'
import r12 from './r12.png'
import r13 from './r13.png'
import r14 from './r14.png'
import r15 from './r15.png'
import r16 from './r16.png'
import r17 from './r17.png'
import r18 from './r18.png'
import r19 from './r19.png'

const GenerateReport = () => {
  return (
    <div className={styles.solutionContainer}>
      <img src={r1} alt="" />
      <img src={r2} alt="" />
      <img src={r3} alt="" />
      <img src={r4} alt="" />
      <img src={r5} alt="" />
      <img src={r6} alt="" />
      <img src={r7} alt="" />
      <img src={r8} alt="" />
      <img src={r9} alt="" />
      <img src={r10} alt="" />
      <img src={r11} alt="" />
      <img src={r12} alt="" />
      <img src={r13} alt="" />
      <img src={r14} alt="" />
      <img src={r15} alt="" />
      <img src={r16} alt="" />
      <img src={r17} alt="" />
      <img src={r18} alt="" />
      <img src={r19} alt="" />
    </div>
  )
}

export default GenerateReport
